export default "__VITE_ASSET__BXU_Tito__"